import { createContext, useContext } from 'react';

/**
 * Copy for arms C (`trimmed`) and D (`trimmed_headline`) of the /challenges
 * registration test (Rob approved both on 2026-10-20).
 *
 * WHY: C is A's page with the repeats removed (one badge, one date row with an
 * inline countdown, one compact host row) so the first form field shows on the
 * first phone screen. D is C with a real-money headline and subheading. Both
 * render A's page component, A's layout and the one shared registration form
 * in ChallengePage. The experiment wrapper provides this value; null (the
 * default) means A's own page, unchanged.
 *
 * C keeps A's words for the headline and subheading: null here means "use the
 * catalog's course title and session group description", exactly as A does.
 * Dates and the countdown always come from the catalog session rows.
 *
 * Spec: MarketingManager/docs/investigations/2026-10-20_businessgrowr-vsl-funnel-and-recommendations.md
 * section 6.
 */
export type ChallengeTrimmedCopy = {
  badge: string;
  heading: string | null;
  subheading: string | null;
};

export const CHALLENGE_TRIMMED_COPY: ChallengeTrimmedCopy = {
  badge: 'Free · Live on Zoom with Rob',
  heading: null,
  subheading: null,
};

export const CHALLENGE_TRIMMED_HEADLINE_COPY: ChallengeTrimmedCopy = {
  // Short enough for one line at 375px (2026-10-21 research, pre-launch fix).
  badge: 'Free 7-Day Challenge · Live on Zoom',
  heading: 'Watch AI Trade Real Money, Live',
  subheading:
    'Rob sets up an AI that researches the market and trades with real money, live on Zoom.',
};

/** Shared by C and D. */
export const CHALLENGE_TRIMMED_HOST_CREDENTIALS =
  '$3B+ in transactions at Greystone · 15+ years in fintech';
export const CHALLENGE_TRIMMED_CTA = 'Save My Free Seat';
export const CHALLENGE_TRIMMED_REASSURE = 'Free. No credit card.';
export const CHALLENGE_TRIMMED_COUNTDOWN_LABEL = 'starts in';

export const ChallengeTrimmedCopyContext = createContext<ChallengeTrimmedCopy | null>(null);

export const useChallengeTrimmedCopy = (): ChallengeTrimmedCopy | null =>
  useContext(ChallengeTrimmedCopyContext);
